import React, { useState} from 'react'
import './TransferForm.css' 
import EditIcon from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom'
import Autocompete from "../JobRequisition/Autocompete";
import {
  TextField
 
} from "@material-ui/core";
export default function TransferForm() {
  const [disabled, setDisabled] = useState(true);
    function update(){
      setDisabled(false);
    }
    function save()
    {
      setDisabled(true);
    }
  return (
   
    <> 

    <div class ="TransferForm">
      <div className="update-button">
    </div>
    <div className='start'>
      <div className="start-heading">
      <h1>Start Details</h1>
      <EditIcon  onClick={update} className="icon-update" />
      <br/>
      </div>
      
      <h3>When do you want this change to take this effect</h3>
      <TextField
        id="date"
        type="date"
        disabled={disabled}
        style={{ padding: "10px", color: "black" , width:"300px"}}
        defaultValue="YYYY/MM/DD"
        InputLabelProps={{
          shrink: true,

        }}/>
        <h3>Why are you making the change?</h3>
        <input type="text"  className='transfer-field'disabled={disabled}/>
        <h3>Who will manage after this change ?</h3><br/>
        <input type="text" className='transfer-field' disabled={disabled}/>
        <br/>
        <h3>Which team will the person to be on after this change ?</h3><br/>
        <input type="text" disabled={disabled} className='transfer-field'/>
     < h3>where will the person be located after this change?</h3>  <br/>
     <input type="text"  className='transfer-field'disabled={disabled}/>

     <div className='next-bar'>
    <button className='back-btn' onClick={save}>save</button>
    <Link to="/transfer/job">   <button className='next-btn' >next</button></Link>
          
        </div>
      </div>
      
       
       
    
          
        </div>
        </>
  )
}
